
export const GLOBAL_SEARCH_SET_RESULTS = 'GLOBAL_SEARCH_SET_RESULTS';
export const GLOBAL_SEARCH_SET_RESULTS_COLUMN_META = 'GLOBAL_SEARCH_SET_RESULTS_COLUMN_META';
export const GLOBAL_SEARCH_SET_SEARCHKEY = 'GLOBAL_SEARCH_SET_SEARCHKEY';
export const GLOABL_SEARCH_SET_PAGENATION = 'GLOABL_SEARCH_SET_PAGENATION';
export const GLOBAL_SEARCH_SET_SEARCHMETHOD = 'GLOBAL_SEARCH_SET_SEARCHMETHOD';



// WEBPACK FOOTER //
// ./src/views/GlobalSearch/flow/actionType.js